// extracted by mini-css-extract-plugin
module.exports = {"styledDropdownMenu":"Uo80pbHS","optionWrapper":"wvuP9aFn","label":"LaUeiYGB","styledInput":"YOeOKvIu","styledButton":"zGGwlXZa"};